module.exports = __webpack_public_path__ + "img/iOS@3x.18ff99a2.png";